/* tslint:disable */
/* eslint-disable */
/**
 * Oil refinery process modeling system
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {mapValues} from '../runtime';
/**
 *
 * @export
 * @interface DeleteActionResult
 */
export interface DeleteActionResult {
  /**
   *
   * @type {boolean}
   * @memberof DeleteActionResult
   */
  treeChanged?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof DeleteActionResult
   */
  success: boolean;
  /**
   *
   * @type {string}
   * @memberof DeleteActionResult
   */
  errorMsg?: string | null;
}

/**
 * Check if a given object implements the DeleteActionResult interface.
 */
export function instanceOfDeleteActionResult(value: object): value is DeleteActionResult {
  if (!('success' in value) || value['success'] === undefined) return false;
  return true;
}

export function DeleteActionResultFromJSON(json: any): DeleteActionResult {
  return DeleteActionResultFromJSONTyped(json, false);
}

export function DeleteActionResultFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): DeleteActionResult {
  if (json == null) {
    return json;
  }
  return {
    treeChanged: json['tree_changed'] == null ? undefined : json['tree_changed'],
    success: json['success'],
    errorMsg: json['error_msg'] == null ? undefined : json['error_msg']
  };
}

export function DeleteActionResultToJSON(value?: DeleteActionResult | null): any {
  if (value == null) {
    return value;
  }
  return {
    tree_changed: value['treeChanged'],
    success: value['success'],
    error_msg: value['errorMsg']
  };
}
